import _ from 'lodash';
import globalStore from '$$globalStore';
import app from '$$app';

function onTaskAttachementDeleted(event) {
  const tasksToUpdateMap = {};
  let ids = [];

  if (event.data?.ids.length) {
    ids = event.data.ids;
  } else if (event.data?.taskIds.length) {
    event.data.taskIds.forEach(tid => {
      const taskData = globalStore.getters['tasksModel/getTask'](tid);

      if (taskData && taskData.attachments?.length) {
        ids.push(...taskData.attachments.map(attachment => attachment.id));
      }
    });
  }

  ids.forEach(deletedId => {
    const storeAttachment = globalStore.getters['attachments/getAttachmentById'](deletedId);

    if (!storeAttachment) {
      return;
    }

    const taskData = globalStore.getters['tasksModel/getTaskByGanttId'](storeAttachment.projectId, storeAttachment.taskId);

    if (!taskData) {
      console.warn(`[attachments::_wsHandleFileUpload] -> no task data for: ${storeAttachment.projectId} ${storeAttachment.taskId}`);

      return;
    }

    globalStore.commit('attachments/removeAttachment', { projectId: storeAttachment.projectId, attachmentId: deletedId, fromGantt: false }, { root: true });

    const hasAttachments = tasksToUpdateMap[storeAttachment.taskId] ? tasksToUpdateMap[storeAttachment.taskId].hasAttachments - 1 : +taskData.hasAttachments - 1;

    tasksToUpdateMap[storeAttachment.taskId] = {
      id: +storeAttachment.taskId,
      gantt_id: +taskData.gantt_id,
      hasAttachments,
    };

    // app.trigger(ID_EVENT_COLLABORATION_UPDATEDMODELS);
    // gantt.callEvent('removeTaskAttachmentNotification', [storeAttachment.projectId, storeAttachment.taskId, 1, taskData.hasAttachments, storeAttachment]);
  });

  if (!_.isEmpty(tasksToUpdateMap)) {
    globalStore.commit('tasksModel/updateTasks', { tasks: Object.values(tasksToUpdateMap), fromGantt: false }, { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    ids: event.data.ids,
    tasks: event.innerSettings.attachmentForSockets.map(i => i.task_id),
  });
}

export default onTaskAttachementDeleted;
